<app-data-table
  [dataSource]="datasource()"
  [useCalculatedMaxHeight]="true"
  [hasDivider]="false"
  [centered]="true"
  [useMarginBottom]="false"
  [useSelection]="viewContext().allowMultiSelect()"
  [selectionModel]="datasource().selection"
  [useDefaultSearch]="false"
  [hidePaginator]="true"
  (sortChange)="onSortChange($event)">
  <ng-container class="before-left-card-actions">
    <app-files-search-and-sort
      [fileSearch]="fileSearch()"
      [datasource]="datasource()"
      [viewContext]="viewContext()"
      [showSortOptions]="false">
    </app-files-search-and-sort>
    <div class="file-count">
      <span>{{ datasource().itemCount }} </span>
      <span>{{ 'Files.Table.FileCount' | translate: locale.language }}</span>
    </div>
    @if (datasource().selection.hasValue() && viewContext().allowMultiSelect()) {
      <div class="delete-files-action">
        <button mat-raised-button color="warn" (click)="deleteSelected()" [disabled]="!!deleteJob()">
          <mat-icon>delete</mat-icon>
          {{ 'Files.Management.DeleteSelected' | translate: locale.language }}
          ({{ datasource().selection.selected.length }})
        </button>
      </div>
    }
  </ng-container>
</app-data-table>
